var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-login h-100"},[_c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{attrs:{"id":"navi"}}),_c('Play')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }